import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { apiErrorText } from "@/lib/api";
import { Airplane } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Conta criada com sucesso");
      navigate("/");
    } catch (err) {
      toast.error(apiErrorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="register-form">
        <div className="flex items-center gap-3 mb-6">
          <img src="/assets/logo.png" alt="SkyInspect" className="w-12 h-12 object-contain rounded-md bg-white/95 p-1" />
          <div className="label-tech text-primary">// novo operador</div>
        </div>
        <h1 className="text-4xl font-black tracking-tighter" style={{ fontFamily: "Manrope" }}>Criar Conta</h1>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label className="label-tech">Nome</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
          </div>
          <div className="space-y-2">
            <Label className="label-tech">E-mail</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
          </div>
          <div className="space-y-2">
            <Label className="label-tech">Senha</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" />
          </div>
        </div>
        <Button type="submit" disabled={loading} className="w-full h-11 font-bold" data-testid="register-submit">
          {loading ? "Criando..." : "CRIAR CONTA"}
        </Button>
        <div className="text-center text-sm text-muted-foreground">
          Já tem conta? <Link to="/login" className="text-accent font-semibold hover:underline">Entrar</Link>
        </div>
      </form>
    </div>
  );
}
